import { Flex, Spin } from 'antd';
import React from 'react';

const LoadingContent = () => {
    return (
        <Flex justify='center'>
            <Spin />
        </Flex>
    );
};

export default LoadingContent;